export default "__VITE_ASSET__8396d702__"